<button mdbBtn [ngClass]="colorClass()" [size]="size" type="button" [outline]="outline" [rounded]="rounded"  [disabled]="disabled"
    (click)="onClick()" mdbWavesEffect>{{title}}</button>
